import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Translate, I18n } from 'react-redux-i18n';
import Modal from '../Modal';
import {
  editPassword as actionEditPassword,
  setPassword as actionSetPassword,
} from '../../actions/auth';
import './settings-rts.scss';

class ChangePassword extends React.PureComponent {
  constructor(...args) {
    super(...args);

    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.handleNewPasswordConfirmChange = this.handleNewPasswordConfirmChange.bind(
      this
    );
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.setNewPassword = this.setNewPassword.bind(this);

    this.state = {
      newPassword: '',
      newPasswordConfirm: '',
      password: '',
      newPasswordValid: false,
      newPasswordConfirmValid: false,
    };
  }

  handleNewPasswordChange(event) {
    const newPassword = event.target.value;
    const newPasswordValid = newPassword.length >= 8;
    this.setState({ newPassword, newPasswordValid });
  }

  handleNewPasswordConfirmChange(event) {
    const newPasswordConfirm = event.target.value;
    const newPasswordConfirmValid = newPasswordConfirm === this.state.newPassword;
    this.setState({ newPasswordConfirm, newPasswordConfirmValid });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  setNewPassword(event) {
    event.preventDefault();
    const { dispatch, hasPassword, close } = this.props;

    if (hasPassword) {
      dispatch(actionEditPassword(this.state.password, this.state.newPassword));
    } else {
      dispatch(actionSetPassword(this.state.newPassword));
      close();
    }

    this.setState({ password: '', newPassword: '', newPasswordConfirm: '' });
  }

  render() {
    const {
      newPassword,
      newPasswordConfirm,
      password,
      newPasswordValid,
      newPasswordConfirmValid,
    } = this.state;
    const { show, close, hasPassword } = this.props;

    const passEnabled = newPasswordValid && newPasswordConfirmValid;

    let newPasswordClass = '';
    let newPasswordValidMessage = '';
    if (newPassword) {
      if (newPasswordValid) newPasswordClass = 'has-success';
      else {
        newPasswordClass = 'has-error';
        newPasswordValidMessage = (
          <Translate value="register.errors.password.length" />
        );
      }
    }

    let newPasswordConfirmClass = '';
    let newPasswordConfirmMessage = '';
    if (newPasswordConfirm) {
      if (newPasswordConfirmValid) newPasswordConfirmClass = 'has-success';
      else {
        newPasswordConfirmClass = 'has-error';
        newPasswordConfirmMessage = (
          <Translate value="register.errors.password.differ" />
        );
      }
    }

    return (
      <Modal
        show={show}
        close={close}
        hideClose
        dialogClassName="rts-settings-modal"
        id="modal-changePassword"
      >
        <div className="rts-settings-modal__inner">
          <div className="rts-settings-modal__header">
            <h2 className="rts-settings-modal__title">
              <Translate value="settings.personal.password.title" />
            </h2>
            <button
              type="button"
              className="rts-settings-modal__close"
              onClick={close}
              aria-label="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>

          <div className="rts-settings-modal__body">
            <form onSubmit={this.setNewPassword}>
              <input type="email" hidden autoComplete="email" />

              {hasPassword && (
                <div className="rts-settings-modal__field">
                  <span>
                    <Translate value="settings.personal.editProfile.oldPassword" />
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    placeholder={I18n.t(
                      'settings.personal.editProfile.oldPassword'
                    )}
                    value={password}
                    onChange={this.handlePasswordChange}
                    autoComplete="current-password"
                  />
                </div>
              )}

              <div className={`rts-settings-modal__field ${newPasswordClass}`}>
                <span>
                  <Translate value="placeholder.password" />
                </span>
                <input
                  type="password"
                  className="form-control"
                  placeholder={I18n.t('placeholder.password')}
                  value={newPassword}
                  onChange={this.handleNewPasswordChange}
                  autoComplete="new-password"
                />
                {newPasswordValidMessage && (
                  <span className="help-block">{newPasswordValidMessage}</span>
                )}
              </div>

              <div
                className={`rts-settings-modal__field ${newPasswordConfirmClass}`}
              >
                <span>
                  <Translate value="placeholder.repeatpassword" />
                </span>
                <input
                  type="password"
                  className="form-control"
                  placeholder={I18n.t('placeholder.repeatpassword')}
                  value={newPasswordConfirm}
                  onChange={this.handleNewPasswordConfirmChange}
                  autoComplete="new-password"
                />
                {newPasswordConfirmMessage && (
                  <span className="help-block">{newPasswordConfirmMessage}</span>
                )}
              </div>

              {hasPassword && (
                <Link to="/i/reset" className="rts-settings-modal__link">
                  <Translate value="settings.personal.password.forgotPassword" />
                </Link>
              )}
            </form>
          </div>

          <div className="rts-settings-modal__footer">
            <button
              type="button"
              className="rts-settings-modal__btn rts-settings-modal__btn--primary"
              disabled={!passEnabled}
              onClick={this.setNewPassword}
            >
              <Translate value="settings.personal.password.change" />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

ChangePassword.propTypes = {
  dispatch: PropTypes.func.isRequired,
  hasPassword: PropTypes.bool,
  show: PropTypes.bool,
  close: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    hasPassword: state.auth.hasPassword,
  };
}

export default connect(mapStateToProps)(ChangePassword);
